// Components
import Skeleton from '@mui/material/Skeleton';
import SkeletonProduct from '../SkeletonProduct';

// Styles
import styles from './index.module.sass';

export default function LoadingProducts({ screenSize }) {
  const productArray = Array(8).fill(0);

  return (
    <div className={`${styles.loadingProducts} ${styles[screenSize]}`}>
      <div className={styles.gridTitle}>
        <Skeleton variant='rectangular' animation='wave' className={styles.title} />
        <Skeleton variant='rectangular' animation='wave' className={styles.subtitle} />
      </div>
      <div className={styles.loadingGrid}>
        {productArray.map((val, key) => {
          return (
            <div className={styles.product} key={key}>
              <SkeletonProduct />
            </div>
          );
        })}
      </div>
    </div>
  );
}
